import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_4: FaireProductEntity = {
  token: "viverano-4",
  type: "product",
  name: "Fair Isle Baby Girl Sweater Knit Dress (Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8d13bdfdf19fd855731b832973ca1a61c71fde580fab70f15836eec3da9513fa.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1023,1025,x0,y127,safe&width=720",
  priceDollars: 26.5,
  msrpDollars: 45,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
